var _rect, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#003D76",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 2,
    y: 3,
    rx: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 16,
    y1: 21,
    y2: 21
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12,
    y1: 17,
    y2: 21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.710fc2a378a3a0e060773c57381a4713.svg";
export { ForwardRef as ReactComponent };